const isElecwattProd = () => {
  return window.location.host.startsWith("www.ljp.elecwatt.com");
};
const isElecwattDev = () => {
  return window.location.host.startsWith("test.ljp.elecwatt.com");
};

export { isElecwattDev, isElecwattProd };
